module.exports = __webpack_public_path__ + "assets/9d4d1fab9416baef62b9aba4ee5ff1d1.mp4";